module.exports = __webpack_public_path__ + "img/ng.edb0fc52.svg";